import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { createLink, type LinkComponent } from '@tanstack/react-router';

type BasicLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const BasicLinkComponent = React.forwardRef<HTMLAnchorElement, BasicLinkProps>((props, ref) => {
  return (
    <a
      ref={ref}
      {...props}
      className={cn(
        '$tw-block $tw-text-foreground hover:$tw-text-foreground hover:$tw-no-underline',
        props.className
      )}
    />
  );
});

const CreatedLinkComponent = createLink(BasicLinkComponent);

export const CustomLink: LinkComponent<typeof BasicLinkComponent> = (props) => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};
